import { Routes } from '@angular/router';

export const formulariosWizardRoutes: Routes = [
  { 
    path: '', 
    loadComponent: () => import('./step-info/step-info.component').then(m => m.StepInfoComponent) 
  },
  { 
    path: 'perguntas', 
    loadComponent: () => import('./step-perguntas/step-perguntas.component').then(m => m.StepPerguntasComponent) 
  }
];
